import { useIntl } from "react-intl";
import { headerMessages as messages } from "src/domain/TopNav/TopNav.messages";
import { getCarHireDeeplinkRedirectUrl } from "src/utils/url";
import useSearch from "src/utils/hooks/useSearch";
import { generateExitPoint } from "src/analytics/exits/generateExitPoint/generateExitPoint";
import { useFallbackPlaceForDeeplink } from "src/utils/hooks/useFallbackPlaceForDeeplink";
import { preferredNameFromPlace } from "src/utils/adapters/place";
import { useHotelDestinationFromUrl } from "src/utils/hooks/useHotelDestinationFromUrl";
import type { AnalyticsEventCategory } from "src/analytics/analyticsEventTypes";
import type { PropsWithChildren } from "react";
import { ExitLink } from "src/exits/components/ExitLink";

export function CarLink(
  props: Readonly<
    PropsWithChildren<{
      className?: string;
      eventCategory: AnalyticsEventCategory;
    }>
  >,
) {
  const intl = useIntl();
  const { searchResponse } = useSearch();
  const deeplinkPlaceFallback = useFallbackPlaceForDeeplink();
  const intendedDestination = useHotelDestinationFromUrl();

  const deeplinkLocation = preferredNameFromPlace(
    intendedDestination ?? deeplinkPlaceFallback,
  );
  const carHireExitPoint = generateExitPoint("genericMap", "headerCarHire");

  const baseCarHireUrl = getCarHireDeeplinkRedirectUrl(
    searchResponse?.request.requestId,
    carHireExitPoint,
    deeplinkLocation,
    deeplinkPlaceFallback.lat,
    deeplinkPlaceFallback.lng,
  );

  return (
    <ExitLink
      href={baseCarHireUrl}
      className={props.className}
      target="_blank"
      rel="nofollow noreferrer"
      kind="RentalCars"
      exitPoint={{
        view: "genericMap",
        trigger: "headerCarHire",
      }}
      onExit={({ sendExitInteractionEvent }) => {
        sendExitInteractionEvent({
          category: props.eventCategory,
          action: "Click:CarHire",
        });
      }}
    >
      {props.children ?? intl.formatMessage(messages.cars)}
    </ExitLink>
  );
}
